<template>
    <v-layout row wrap align-center>
        <v-flex xs4>
            <div class="logo-container" :style="{'background-image':'url('+(listing.logoUrl)+')'}"></div> 
        </v-flex>
        <v-flex xs8 class="pl-3">
            <v-checkbox @change="changed()" color="primary" :label="listing.companyName" v-model="added"></v-checkbox>
        </v-flex>
    </v-layout>
</template>


<script>
export default {
    props:['listing', 'listingKey'],

    data() {
        return {
            added:true
        }
    },


    methods: {
        changed() {
            this.added ? this.addRequest() : this.removeRequest();
        },

        addRequest() {
            this.added = true;
            this.$emit('add-request', this.listingKey);
        },

        removeRequest() {
            this.added = false;
            this.$emit('remove-request', this.listingKey);
        }
    }
}

</script>


<style scoped>
    .logo-container {
        position: relative;
        height: 0;
        overflow: hidden;
        padding-top:66%;
        background-size: contain;
        background-position: 50%;
    }
</style>